import {asset} from 'imba';
import url from './heart.svg';

export default /* @__PURE__ */ asset({
	url: url,
	type: 'svg',
	meta: {"attributes":{"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"},"flags":[],"content":"\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M48 0H0V48H48V0ZM15.5625 7C10.0359 7 6 12.6409 6 18.7241C6 32.3045 24 41 24 41C24 41 42 31.7444 42 18.7241C42 12.6419 37.9647 7 32.4375 7C28.6022 7 25.7565 9.53111 24 13.1211C22.2434 9.53088 19.3976 7 15.5625 7Z\" fill=\"#333333\"/>\n\n"},
	toString: function(){ return this.url;}
})